import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

export default styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],
}));
